import { deserialize } from "flatgeobuf/lib/mjs/geojson";
import { PARCELS_FGB_PATH } from "../constants";

/**
 * bbox - EPSG:4326 lng/lat
 */
async function getParcelsInBbox(bbox: { minX: number; minY: number; maxX: number; maxY: number }): Promise<GeoJSON.Feature[]> {
	const features: GeoJSON.Feature[] = [];

	for await (const feature of deserialize(PARCELS_FGB_PATH, bbox)) {
		features.push(feature);
	}

	return features;
}

export { getParcelsInBbox };
